import { render, staticRenderFns } from "./update-user-info-for-team.html?vue&type=template&id=5721c47b&scoped=true&external"
import script from "./update-user-info-for-team.js?vue&type=script&lang=js&external"
export * from "./update-user-info-for-team.js?vue&type=script&lang=js&external"
import style0 from "./update-user-info-for-team.scss?vue&type=style&index=0&id=5721c47b&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5721c47b",
  null
  
)

export default component.exports